import { apiWithAuth } from "../authApi";
import { Wallet } from "@/modules/user/types/wallet";

export const getMyWallet = async (): Promise<Wallet | undefined> => {
  try {
    const response = await apiWithAuth.get("/wallet/my-wallet");

    const answer = response.data as Wallet;

    return answer;
  } catch (error) {
    return undefined;
  }
};
